export default {
    name: 'ShowPasswordInput',
    data() {
        return {
            isPasswordVisible: false,
            password: ''
        };
    },

    props: {
        placeholder: {
            type: String,
            required: false,
            default: ''
        },
        validator_name: {
            type: String,
            required: false,
            default: 'Contraseña'
        }
    },

    methods: {
        changePassword(value) {
            this.$emit('password_changed', value);
        }
    }
};
